import React from 'react';
import Grid from '../Grid';
import { Section03_Styled, Title, Description, Separator, Item } from './styled';

const itemList = [
  {
    icon: 'https://cdn.auth0.com/website/machine-to-machine/image/secure/icon-backend-v1.svg',
    title: 'Application Backends',
    text:
      'Enable app servers, APIs, and services to make authenticated requests to your API without the need of human interaction.'
  },
  {
    icon: 'https://cdn.auth0.com/website/machine-to-machine/image/secure/icon-cli-v1.svg',
    title: 'CLIs',
    text: 'Build powerful tools and CLIs that can connect and authenticate to your APIs.'
  },
  {
    icon: 'https://cdn.auth0.com/website/machine-to-machine/image/secure/icon-processes-v1.svg',
    title: 'Continuous Processes',
    text: 'Let job schedulers, daemons, and other system processes securely interact with your API.'
  }
];

const Section03 = () => {
  return (
    <Section03_Styled>
      <Grid>
        <Title>
          Secure API Authentication for<br />Non-interactive Apps
        </Title>
        <Description>
          Allow non-interactive applications such as app servers, Command Line Interfaces (CLIs),
          daemons, and others to safely and securely consume your API in cases where no human
          interaction is necessary.
        </Description>
      </Grid>
      <Separator />
      <Grid>
        {itemList.map((item, i) => (
          <Item key={i}>
            <img src={item.icon} alt={item.title} />
            <h4>{item.title}</h4>
            <p>{item.text}</p>
          </Item>
        ))}
      </Grid>
    </Section03_Styled>
  );
};

export default Section03;



// WEBPACK FOOTER //
// ./src/pages/machine-to-machine/components/Section-03/Section-03.js